import React, {useEffect} from 'react';
import {ConfigKeys} from '@src/@types/services/Config/ConfigKeys';
import config from '@src/helpers/config';

export default function useConfigValue<T = any>(key: ConfigKeys, defaultValue: T): T {
    const cfg = config();
    const [value, setValue] = React.useState<T>(cfg.get(key, defaultValue));

    useEffect(() => {
        const subscription = cfg.onValueChanged(key, () => {
            setValue(cfg.get(key, defaultValue));
        });

        return () => subscription.unsubscribe();
    }, [value, cfg, key, defaultValue]);

    return value;
}
